export interface PartnerPracticeDashboardResponse {
    appointments: number;
    bookedToSatPercentage: number;
    satToInstructedPercentage: number;
    instructionValue: number;
    averageCaseSize: number;
    professionalExecutorPercentage: number;
    willLpaConversionRate: number;
    lpaConversionRate: number;
    turnaroundTime: number;
    revenuePerClient: number;
    recoveryRate: number;
    writtenOffRate: number;
    clearedAmount: number;
    bankedAmount: number;
    signingBookedAmount: number;
    predictedBanking: number;
    bankingTarget: number;
    differenceToTarget: number;
    signingPendingAmount: number;
    consideringOptions: number;
    coolingOff: number;
    debtorAmount: number;
    noLongerProceedingAmount: number;
    writtenOffAmount: number;
}

export function createPartnerPracticeDashboardResponse(): PartnerPracticeDashboardResponse {
    return {
        appointments: 0,
        bookedToSatPercentage: 0,
        satToInstructedPercentage: 0,
        instructionValue: 0,
        averageCaseSize: 0,
        professionalExecutorPercentage: 0,
        willLpaConversionRate: 0,
        lpaConversionRate: 0,
        turnaroundTime: 0,
        revenuePerClient: 0,
        recoveryRate: 0,
        writtenOffRate: 0,
        clearedAmount: 0,
        bankedAmount: 0,
        signingBookedAmount: 0,
        predictedBanking: 0,
        bankingTarget: 0,
        differenceToTarget: 0,
        signingPendingAmount: 0,
        consideringOptions: 0,
        coolingOff: 0,
        debtorAmount: 0,
        noLongerProceedingAmount: 0,
        writtenOffAmount: 0,
    };
}
